// extracted by mini-css-extract-plugin
export default {"NavItems":"NavItems_NavItems__6VRVD","navItem":"NavItems_navItem__BQ6em","active":"NavItems_active__aiY4Q"};